import React from 'react'
import { useDrop } from 'react-dnd'

interface DropContentProps {
    onDrop: (v: any) => void
    type: string
    activeStyle?: React.CSSProperties
}

const DropContent: React.FC<DropContentProps> = props => {
    const [{ isOver, canDrop }, drop] = useDrop({
        accept: props.type,
        drop: item => {
            props.onDrop(item)
        },
        collect: monitor => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    })

    const isActive = isOver && canDrop

    return (
        <div
            ref={drop}
            style={
                isActive
                    ? {
                          border: '1px solid red',
                          boxSizing: 'border-box',
                      }
                    : {
                          border: '1px solid transparent',
                      }
            }
        >
            {props.children}
        </div>
    )
}

export default DropContent
